<template>
  <admin-wrapper
    title-translation-path="navbar.zdmStreetLights"
    :has-buttons="false"
    :inputs="inputs"
    :is-fetched="isFetched"
  >
    <template #greyTabs.input>
      <grey-tabs v-model="tab" :tabs="tabs" cols="auto" has-border>
        <v-tab-item>
          <admin-input-row translation-path="admin.datasourcesTypeLight" name="datasource" align="baseline">
            <template #datasource.input>
              <v-row no-gutters>
                <v-col :cols="6">
                  <data-sources-settings-list
                    :data-sources="computedDataSources"
                    :is-fetched="isFetched"
                    :dots-items="[{ name: 'editAttributes' }]"
                    :has-add-button="false"
                  ></data-sources-settings-list>
                </v-col>
              </v-row>
            </template>
          </admin-input-row>
        </v-tab-item>
        <v-tab-item>
          <draggable-lists-layers
            scope="zdm_data"
            :layer-dots-items="[
              {
                name: 'manageLayer',
              },
              {
                name: 'manageCard',
              },
            ]"
            :is-fetched="isFetched"
            schema_scope="zdm_data"
          ></draggable-lists-layers>
        </v-tab-item>
        <v-tab-item>
          <ZDMCatalogsTab :catalogs="enabledComputedCatalogs"></ZDMCatalogsTab>
        </v-tab-item>
        <v-tab-item>
          <ZDMLanternPatternsTab></ZDMLanternPatternsTab>
        </v-tab-item>
      </grey-tabs>
    </template>
  </admin-wrapper>
</template>

<script>
import AdminWrapper from '@/components/AdminWrapper';
import AdminInputRow from '@/components/AdminInputRow';
import DataSourcesSettingsList from '@/components/DataSourcesSettingsList';
import DraggableListsLayers from '@/components/DraggableListsLayers';
import GreyTabs from '@/components/GreyTabs';
import { call, get } from 'vuex-pathify';
import ZDMCatalogsTab from '@/components/ZDMCatalogsTab';
import ZDMLanternPatternsTab from '@/components/ZDMLanternPatternsTab';
export default {
  name: 'ZDMStreetLightsAdmin',
  components: {
    ZDMLanternPatternsTab,
    ZDMCatalogsTab,
    GreyTabs,
    AdminWrapper,
    DataSourcesSettingsList,
    AdminInputRow,
    DraggableListsLayers,
  },
  props: {
    tabProp: {
      type: Number,
      default: 0,
    },
  },
  data: vm => ({
    isFetched: false,
    tab: vm.tabProp,
    tabs: [
      { name: vm.$i18n.t('admin.datasourcesSettings') },
      { name: vm.$i18n.t('navbar.layers') },
      { name: vm.$i18n.t('admin.catalogs') },
      { name: vm.$i18n.t('admin.lanternPatterns') },
    ],
  }),
  computed: {
    modulesMapping: get('admin/modulesMapping'),
    dataSources: get('layers/metadata'),
    catalogs: get('admin/modulesMapping@zdm_data.catalogs'),
    computedDataSources() {
      return Object.values(this.dataSources).filter(
        value => value.scope === 'zdm_data' && !this.computedCatalogsDataSourcesNames.includes(value.name)
      );
    },
    computedCatalogs() {
      return this.catalogs
        ? Object.keys(this.catalogs).map(key => {
            return {
              text: this.$i18n.t(`admin.zdmStreetLights.catalogs.${key}`),
              dataSource: this.catalogs[key].datasource,
              enabled: this.catalogs[key].enabled,
            };
          })
        : [];
    },
    computedCatalogsDataSourcesNames() {
      return this.computedCatalogs.map(catalog => catalog.dataSource);
    },
    enabledComputedCatalogs() {
      return this.computedCatalogs
        .filter(catalog => catalog.enabled)
        .map(catalog => {
          const { text, dataSource } = catalog;
          return { text, dataSource };
        });
    },
    inputs() {
      return [
        {
          name: 'greyTabs',
          hasSuffix: false,
          isCustom: true,
          isNamedSlot: false,
        },
      ];
    },
  },
  methods: {
    getDataSourceForm: call('layers/getDataSourceForm'),
    getLayerMetadata: call('layers/getLayerMetadata'),
    getModulesMapping: call('admin/getModulesMapping'),
    getDataSources: call('layers/getLayersMetadata'),
    getLayersSchemaByScope: call('layers/getLayersSchemaByScope'),
    async init() {
      await this.getModulesMapping();
      await this.getDataSources({ with_attributes_schema: true, scope: 'zdm_data' });
      await Promise.all([this.getLayersSchemaByScope({ layer_scope: 'zdm_data', schema_scope: 'zdm_data' })]);
      this.isFetched = true;
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped lang="scss"></style>
